import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../core/environment.tokens";
import { ListItem } from "../../../../../shared/list/list-item";
import { MenuItem } from "../../../../../shared/menu/menu-item.model";

@Injectable()
export class InternalPendsDetailHeaderService {
  reset = new Subject<any>();
  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService,
    private route: ActivatedRoute
  ) { }

  getPendGdFromPath(): number {

    return this.route.snapshot.params.pendGd;
  }

  getMenuItems(): Observable<MenuItem[]> {
    const url = `${this.baseApiUrl}Pend/MenuItems`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default-sub-menu", "MenuItem"))
    );
  }
  resetFunction(pendId: number) {

    this.reset.next(pendId);
  }

  getPendHeaderInfo(pendId): Observable<ListItem[]> {

    const url = `${this.baseApiUrl}Pend/PendHeaderInfo?pendId=${pendId}`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "ListItem"))
    );
  }
}
